// src/json/overlayData.json
export const overlaySectionBuildingEnvelopeRenewals = {
    imageUrl: "/assets/imgs/services/1BuildingEnvelopeRenewals/overlaySection/fondo.jpg",
    text: "The best Building Envelope Renewal /",
    highlight: "High-Rise Painting & Restoration services."
};
